import { render, staticRenderFns } from "./TessProfile.vue?vue&type=template&id=10973f7a&"
import script from "./TessProfile.vue?vue&type=script&lang=ts&"
export * from "./TessProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports